import { Flow } from '../../License/types/enums';

import { ConsignmentTabFields, HeaderTabFields } from '../../License/types/fieldEnums';

import type { IComparisonField } from '../types';

function getConsignmentTabFields(flow: Flow): IComparisonField[][] {
  return [
    [
      {
        label: flow === Flow.EX ? 'Country of Destination' : 'Country of Export',
        fieldKey: HeaderTabFields.countryOfDestinationCode,
        tagKey: HeaderTabFields.countryOfDestinationName,
      },
      {
        label: 'Transit Country',
        fieldKey: ConsignmentTabFields.transitCountryCode,
        tagKey: ConsignmentTabFields.transitCountryName,
      },
      {
        label: 'First Point Of Arrival',
        fieldKey: ConsignmentTabFields.firstPointOfArrival,
      },
      {
        label: 'Mean Of Transport',
        fieldKey: ConsignmentTabFields.meanOfTransportCode,
        tagKey: ConsignmentTabFields.meanOfTransportName,
      },
      {
        label: 'Transport Means Of Identity',
        fieldKey: ConsignmentTabFields.transportMeansOfIdentity,
      },
      {
        label: 'Voyage Number',
        fieldKey: ConsignmentTabFields.voyageNumber,
      },
    ],
  ];
}

export default getConsignmentTabFields;
